import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToHash from "@/components/ScrollToHash";
import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import Signup from "@/pages/Signup";
import SignupSuccess from "@/pages/SignupSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Account from "@/pages/Account";
import ResetPassword from "@/pages/ResetPassword";
import WidgetGate from "@/pages/WidgetGate";
import GetStarted from "@/pages/GetStarted";
import Setup from "@/pages/Setup";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import { Terms, Privacy } from "@/pages/Legal";
import { getAdminToken } from "@/lib/api";

function RequireAdmin({ children }) {
  return getAdminToken() ? children : <Navigate to="/admin" replace />;
}

// Chrome (CookieBanner + Toaster) that must never appear on the public /widget/*
// routes — those pages MUST render a truly blank div when the widget is disabled.
function GlobalChrome() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/widget/")) return null;
  return (
    <>
      <CookieBanner />
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0A1628",
            border: "1px solid rgba(6,182,212,0.3)",
            color: "#F8FAFC",
          },
        }}
      />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          {/* Public widget — no chrome, no banner */}
          <Route path="/widget/:widgetId" element={<WidgetGate />} />

          {/* Admin */}
          <Route path="/admin" element={<><Navbar /><AdminLogin /><Footer /></>} />
          <Route
            path="/admin/dashboard"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />

          {/* Marketing + tenant pages */}
          <Route path="/" element={<><Navbar /><Home /><Footer /></>} />
          <Route path="/pricing" element={<><Navbar /><Pricing /><Footer /></>} />
          <Route path="/signup" element={<><Navbar /><Signup /><Footer /></>} />
          <Route path="/signup/success" element={<><Navbar /><SignupSuccess /><Footer /></>} />
          <Route path="/get-started" element={<><Navbar /><GetStarted /><Footer /></>} />
          <Route path="/setup" element={<><Navbar /><Setup /><Footer /></>} />
          <Route path="/blog" element={<><Navbar /><Blog /><Footer /></>} />
          <Route path="/blog/:slug" element={<><Navbar /><BlogPost /><Footer /></>} />
          <Route path="/terms" element={<><Navbar /><Terms /><Footer /></>} />
          <Route path="/privacy" element={<><Navbar /><Privacy /><Footer /></>} />
          <Route path="/account" element={<><Navbar /><Account /><Footer /></>} />
          <Route path="/reset-password" element={<><Navbar /><ResetPassword /><Footer /></>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <GlobalChrome />
      </BrowserRouter>
    </div>
  );
}

export default App;
